import { makeVar } from "@apollo/client"
import type { Maybe } from "type-graphql"
import type { VisualBynderType } from "types"

// ui related variable
export const wasMembershipAddedToBasket = makeVar<boolean>(false) // Used to determine if a membership was just added to basket in the ATB confirmation modal for rendering a membership card
export const pdpQuantityVar = makeVar(1)
export const freeGiftModalVar = makeVar(false)
export const basketModalVar =
  makeVar<
    Maybe<
      | "memberships"
      | "overspend"
      | "freegift"
      | "freegiftjapanfusion"
      | "freegiftpureoxygen"
      | "freegiftyouthboosting"
    >
  >(null)
export const pdpModalVar = makeVar<Maybe<"insider">>(null)
export const popupImageVar = makeVar<Maybe<VisualBynderType>>(null)
export const addToBagModalOpenVar = makeVar(false)
export const adjustHeaderAlignmentVar = makeVar(false)
export const basketOperationInFlightVar = makeVar(false)
export const duplicateRafRedemptionModalVar = makeVar(false)
export const isFirstProductAddedVar = makeVar(false)
